import React from "react";
import {
  FaArrowLeft,
  FaFacebookF,
  FaLinkedinIn,
  FaPaperPlane,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";

import footerBg from "../assets/img/footer/bg.png";
import mapMarker from "../assets/img/icon/map-marker.png";
import phone from "../assets/img/icon/phone.png";
import clock from "../assets/img/icon/clock.png";
import logo from "../assets/img/logo-white.png";

const Footer = () => {
  return (
    <>
      {/* footer area start */}
      <footer className="footer-area">
        <div
          className="footer-top"
          style={{ backgroundImage: `url(${footerBg})` }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-top">
                  <div className="icon">
                    <img src={mapMarker} alt="Aras" />
                  </div>
                  <div className="details">
                    <h6>آدرس مرکزی</h6>
                    <p>
                      اصفهان ، سپاهان شهر ، بلوار غدیر ، خیابان تعاون ۳ ، پلاک
                      ۴۷ ( مسیریابی )
                    </p>
                    <p> کدپستی : ۸۱۷۹۹۵۳۶۶۶</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-top">
                  <div className="icon">
                    <img src={mapMarker} alt="Aras" />
                  </div>
                  <div className="details">
                    <h6>دفتر تهران</h6>
                    <p>
                      میدان آرژانتین ، خیابان خالد اسلامبولی ، کوچه ۸ ، پلاک ۳ ،
                      طبقه اول ، واحد ۳
                    </p>
                    <p>تلفن : ۸۸۷۲۹۰۲۶- ۸۸۷۲۹۵۲۷ – ۰۲۱</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-top after-none">
                  <div className="icon">
                    <img src={phone} alt="Aras" />
                  </div>
                  <div className="details">
                    <h6>اطلاعات تماس</h6>
                    <p>info@asiaseiraras.ir</p>
                    <p>تلفن : ۸-۳۶۵۰۵۰۲۶-۰۳۱ </p>
                    <p>فکس : ۳۶۵۰۴۷۹۸-۰۳۱</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-md-6">
              <div className="widget widget_about">
                <div className="thumb">
                  <img src={logo} alt="Aras" />
                </div>
                <div className="details">
                  <p>
                    این شرکت در سال ۱۳۸۲ و با سرمایه گذاری ۱۰۰درصد بخش خصوصی
                    تاسیس و به عنوان یکی از شرکت های زیر مجموعه توکاریل و هلدینگ
                    سرمایه گذاری توکا فولاد ، فعالیت خود را در زمینه حمل و نقل
                    ریلی آغاز نمود.
                  </p>
                  <ul className="social-media style-border">
                    {/* <li>
                      <Link href="#">
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <FaWhatsapp />
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <FaLinkedinIn />
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">لینک های کاربردی</h4>
                <ul>
                  <li>
                    <Link to="/about">
                      <FaArrowLeft /> آگهی مجامع
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      <FaArrowLeft /> پخش زنده جلسات
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FaArrowLeft /> شرکت سرمایه گذاری فولاد
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog">
                      <FaArrowLeft />
                      شرکت توکاریل
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact">
                      <FaArrowLeft /> شرکت توکافولاد
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-md-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">خدمات های مهم</h4>
                <ul>
                  <li>
                    <Link href="/service-details">
                      <FaArrowLeft /> باربری
                    </Link>
                  </li>
                  <li>
                    <Link href="/service-details">
                      <FaArrowLeft /> حمل و نقل بار
                    </Link>
                  </li>
                  <li>
                    <Link href="/service-details">
                      <FaArrowLeft /> انبارداری
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="widget widget_subscribe">
                <h4 className="widget-title">خبرنامه</h4>
                <p>
                  برای دریافت آخرین مقالات و اخبار شرکت آسیا سیر ارس ایمیل خود
                  را ثبت نمایید تا در خبرنامه مشترک شوید.
                </p>
                <div className="single-subscribe-inner">
                  <input type="text" placeholder="آدرس ایمیل" />
                  <Link className="btn btn-base" href="#">
                    <FaPaperPlane />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer area end */}
    </>
  );
};

export default Footer;
